<template>
    <div id="swipe" class="swipe">
        <div v-if="noVoucher">
            <div class="swipe-voucher" :style="{marginTop: 15 + 'px', height: (width/3) + 'px'}">
                <div class="swipe-voucher-content" @click="goAddVoucher">
                    <div class="swipe-voucher-item">
                        <p>挂号前请先办卡或绑卡</p>
                        <p class="swipe-voucher-button">绑定电子健康卡</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- 画廊 -->
            <div :style="{width: (width * img.length) + 'px', transform: `translateX(${translateX}px)`}" id="swipe-banner" class="swipe-banner">
                <!-- 画板 -->
                <div v-for="(item, i) in img" :key="i" :style="{width: width + 'px'}" @click="go(img[i].link)">
                    <!-- 画板中的内容 -->
                    <div :class="img[i].src">
                    </div>
                </div>
            </div>
            <div class="swipe-index">
                <span v-for="(item, i) in img" :key="i" :class="{active: (index === i)}"></span>
            </div>
        </div>
    </div>
</template>
<script>
    /*eslint-disable*/
    import personal from 'personal.service'
    export default{
        data() {
            return {
                width: window.innerWidth,
                height: window.innerHeight,
                index: 0,
                translateX: 0,
                interval: null
            }
        },
        props: {
            img: {
                type: Array,
                default: () => ([])
            },
            noVoucher: {
                type: Boolean,
                default: () => (false)
            }
        },
        mounted() {
            setTimeout(() => {
                if (!this.noVoucher && (this.img.length > 1)) {
                    const swipe = document.getElementById('swipe')
                    let startX
                    let endX
                    swipe.addEventListener('touchstart', ($event) => {
                        startX = $event.touches[0].pageX
                        this.endInterval()
                    })
                    swipe.addEventListener('touchmove', ($event) => {
                        endX = $event.touches[0].pageX
                        let distanceX = endX - startX
                        if (distanceX >= 0) { //向右滑动
                            if (this.index > 0) {
                                this.translateX = -(this.index * this.width) + distanceX
                            }
                        } else { //向左滑动
                            if (this.index < (this.img.length - 1)) {
                                this.translateX = -(this.index * this.width) + distanceX
                            }
                        }
                    })
                    swipe.addEventListener('touchend', () => {
                        let distanceX = endX - startX
                        if (Math.abs(distanceX) >= (this.width * 0.25)) {
                            if (distanceX > 0) { //向右滑动
                                if (this.index > 0) {
                                    this.index--
                                }
                            } else { //向左滑动
                                if (this.index < (this.img.length - 1)) {
                                    this.index++
                                }
                            }
                        }
                        this.updateBanner()
                        this.startInterval()
                    })
                    this.startInterval()
                }
            })
        },
        beforeDestroy() {
            this.endInterval()
        },
        methods: {
            updateBanner() {
                const swipeBanner = document.getElementById('swipe-banner')
                swipeBanner.className = 'swipe-banner transition'
                this.translateX = -(this.index * this.width)
                setTimeout(() => {
                    swipeBanner.className = 'swipe-banner'
                }, 250)
            },
            startInterval() {
                this.interval = setInterval(() => {
                    if (this.index === (this.img.length - 1)) {
                        this.index = 0
                    } else {
                        this.index++
                    }
                    this.updateBanner()
                }, 5000)
            },
            endInterval() {
                if (this.interval) {
                    clearInterval(this.interval)
                }
            },
            go(link) {
                if (link) {
                    window.location.href = link
                }
            },
            goAddVoucher() {
                personal.getUserInfo().then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                        this.$utils.alert(res.resultMsg)
                        return
                    }
                    this.$router.push('voucheradd')
                })
            },
        },
    }
</script>
<style lang="scss">
    @import '../../static/sass/_variable.scss';
    .swipe {
        height: 100%;
        div {
            position: relative;
            height: 100%;
            .swipe-voucher {
                /*height: 82%;*/
                .swipe-voucher-content {
                    @include display-flex();
                    @include align-items(center);
                    width: auto;
                    margin-left: 10px;
                    margin-right: 10px;
                    background-color: #ffffff;
                    border-radius: 5px;
                    border: 2px $main-style-color;
                    box-sizing: border-box;
                    .swipe-voucher-item {
                        @include flex();
                        height: 50%;
                        margin: 0 20%;
                        padding-left: 12%;
                        color: #333333;
                        font-size: 15px;
                        background: url(../../static/img/banner-add-card.png) no-repeat left center;
                        background-size: 17%;
                        p {
                            margin-top: 5.5%;
                            &:last-child {
                                margin-top: 2.5%;
                            }
                        }
                        .swipe-voucher-button {
                            display: inline-block;
                            padding: 4% 1%;
                            color: #b1b1b1;
                            font-size: 20px;
                        }
                    }
                }
                .swipe-voucher-img {
                    @include display-flex();
                    @include align-items(center);
                    width: auto;
                    margin-left: 10px;
                    margin-right: 10px;
                    border-radius: 5px;
                    border: 2px $main-style-color;
                    box-sizing: border-box;
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image: url(../../static/img/home-banner.png);
                }
            }
            .swipe-banner {
                height: 100%;
                &.transition {
                    -webkit-transition: all 0.25s linear;
                    -moz-transition: all 0.25s linear;
                    -o-transition: all 0.25s linear;
                    -ms-transition: all 0.25s linear;
                    transition: all 0.25s linear;
                }
                div {
                    float: left;
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                    border: 2px $main-style-color;
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                    box-sizing: border-box;
                    &.index-banner-png {
                        background-image: url(../../static/img/home-banner.png);
                    }
                    &.index-banner-png1 {
                        background-image: url(../../static/img/home-banner1.png);
                    }
                }
            }
            .swipe-index {
                position: absolute;
                bottom: 5%;
                width: 100%;
                height: auto;
                text-align: center;
                span {
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    margin-right: 8px;
                    border-radius: 1em;
                    background-color: $main-style-color;
                    &.active {
                        width: 20px;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Swipe.vue?ad9ddd4c